/*
 * @Author: Junchi Zhao
 * @LastEditors: Please set LastEditors
 * @Description:
 */
function getClientUrl() {
  let url = "";
  //多pathname且包含index.html
  if (window.location.pathname && window.location.pathname.indexOf(".") > -1) {
    url =
      window.location.origin +
      window.location.pathname.substring(
        0,
        window.location.pathname.lastIndexOf("/")
      );
  } else if (window.location.pathname) {
    url = window.location.origin + window.location.pathname;
  } else {
    url = window.location.origin;
  }
  return url;
}
const currentClientURL = getClientUrl();
export const projectName = "智慧牧场管理系统";
export const bsglzxt = "标识管理子系统";
export const bsglzxtEn = "Identification Management Subsystem";
export const cydsjzx = "产业大数据中心<br>后台系统";
export const cydsjzxEn = "Identification Management Subsystem";
export const baglzxt = "备案管理子系统";
export const cyqlzsglxt = "繁育养殖管理子系统";
export const xxfbxt = "信息发布系统";
export const baseURL = process.env.baseURL
  ? process.env.baseURL
  : currentClientURL;
export const uploadURL = process.env.uploadURL
  ? process.env.uploadURL
  : currentClientURL;
export const logURL = process.env.logURL
  ? process.env.logURL
  : currentClientURL;
export const wsURL = process.env.wsURL ? process.env.wsURL : currentClientURL;
export const isOpenWs = false; //是否开启websocket
export const showMessageCount = 2; //设置消息展示数量
export const previewURL = process.env.previewURL; //预览服务地址
export const isWaterMark = true;
export const pwdEncryptType = "SM3";
export const transferEncryptType = "SM4";
export const sliderIndent = 10;
export const isDev = process.env.NODE_ENV == "development";
export const ak = "L3ZcYZyYjuCo7ImVq9Lf3dWlb23uazMS"; //百度地图私钥
export function getGlobalConfig() {
  return {
    baseURL: baseURL,
    uploadURL: uploadURL,
    logURL: logURL,
    wsURL: wsURL,
    isOpenWs: isOpenWs,
    showMessageCount: showMessageCount,
    previewURL: previewURL,
    isWaterMark: isWaterMark,
    pwdEncryptType: pwdEncryptType,
    transferEncryptType: transferEncryptType,
    sliderIndent: sliderIndent,
    isDev: isDev,
    ak: ak,
    bsglzxt: bsglzxt,
    bsglzxtEn: bsglzxtEn,
    cydsjzx: cydsjzx,
    cydsjzxEn: cydsjzxEn,
    baglzxt: baglzxt,
    cyqlzsglxt: cyqlzsglxt,
    xxfbxt: xxfbxt
  };
}



// WEBPACK FOOTER //
// ./src/config.js